import { render } from "./SavedCollectionsBackToSearch.vue?vue&type=template&id=52886c4c&scoped=true"
import script from "./SavedCollectionsBackToSearch.vue?vue&type=script&lang=js"
export * from "./SavedCollectionsBackToSearch.vue?vue&type=script&lang=js"

import "./SavedCollectionsBackToSearch.vue?vue&type=style&index=0&id=52886c4c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52886c4c"]])

export default __exports__